import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { useDocumentTitle } from '@/router/use-document-title';

export interface RouterContext {
  query: QueryClient;
}

function DocumentTitle() {
  useDocumentTitle();
  return null;
}

function RootComponent() {
  return (
    <>
      <DocumentTitle />
      <Outlet />
    </>
  );
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});
